import request from '@/utils/request'

export function login(query) {
    return request({
        url: '/auth/login',
        method: 'POST',
        Headers: { token: NaN },
        data: query
    })
}
export async function Search(query) {
    query["sort"] = "- Weight";
    if (query.filter === undefined) {
        query.filter = { "status": { "_eq": "published" } }
    } else {
        query.filter.status = { "_eq": "published" }
    }
    for (let index = 0; index < 2; index++) {
        var data = await request({ url: '/items/movie', method: 'get', Headers: { token: "" }, params: query })
        if (data.status === 200)
            return data
    }
    return await request({ url: '/items/movie', method: 'get', Headers: { token: NaN }, params: query })
}
export async function GetMovieType() {
    for (let index = 0; index < 2; index++) {
        var data = await request({ url: '/items/category?sort=- Weight', Headers: { token: NaN }, method: 'get' })
        if (data.status === 200)
            return data
    }
    return await request({ url: '/items/category?sort=- Weight', Headers: { token: NaN }, method: 'get' })
}


export async function GetVideoPayInfo(query) {
    for (let index = 0; index < 2; index++) {
        var data = await request({ url: '/items/user_payed_movie', Headers: { token: "" }, method: 'get', params: query })
        if (data.status === 200)
            return data
    }
    return await request({ url: '/items/user_payed_movie', Headers: { token: "" }, method: 'get', params: query })
}

export async function GetUserId(query) {
    for (let index = 0; index < 2; index++) {
        var data = await request({
            url: '/users/me',
            method: 'get',
            Headers: { token: NaN },
            params: query
        })
        if (data.status === 200)
            return data
    }
    return await request({
        url: '/users/me',
        method: 'get',
        Headers: { token: NaN },
        params: query
    })
}
export function checkuser(query) {
    return request({
        url: '/custom/bill/checkuser',
        method: 'post',
        Headers: { token: NaN },
        data: query
    })
}

export function Signup(query) {
    return request({
        url: '/auth/signup',
        method: 'POST',
        Headers: { token: NaN },
        data: query
    })
}


export function refresh(query) {
    return request({
        url: '/auth/refresh',
        method: 'post',
        Headers: { token: NaN },
        data: query
    })
}

export function GetVipInfo(query) {
    return request({
        url: '/items/user_subscribe',
        method: 'get',
        Headers: { token: NaN },
        params: query
    })
}

export function Getpaypalinfo(query) {
    return request({
        url: '/items/paypalinfo',
        Headers: { token: NaN },
        method: 'get',
        params: {
            web_id: process.env.Pay_id,
            sort: "vip_level",
            filter: { "status": { "_eq": "published" } }
        }
    })
}

export function PostBill(query, data) {
    return request({
        url: '/items/bill',
        method: 'post',
        Headers: { token: "" },
        params: query,
        data: data
    })
}


export async function PostBillOne(query, data) {
    for (let index = 0; index < 2; index++) {
        var requestdata = await request({
            url: '/items/user_payed_movie',
            method: 'post',
            Headers: { token: "" },
            params: query,
            data: data
        })
        if (requestdata.status === 200)
            return requestdata
    }
    return await request({
        url: '/items/user_payed_movie',
        method: 'post',
        params: query,
        Headers: { token: "" },
        data: data
    })
}

export function GetMovieInfo(query) {
    return request({
        url: '/items/movie/' + query,
        Headers: { token: "" },
        method: 'get',
    })
}


export function detailsintoCountly(id) {
    return request({
        url: '/newapi/detailsinto',
        Headers: { token: NaN },
        method: 'post',
        data: {
            "movie_id": id
        }
    })
}


export function SubCountly(purchase) {
    return request({
        url: '/items/paypal_events',
        Headers: { token: NaN },
        method: 'post',
        data: {
            "purchase_type": purchase
        }
    })
}






// WEBPACK FOOTER //
// ./src/api/MovieApi.js